import { environment } from '../../environments/environment'
import { revertSwitchUser } from '../store/auth/auth.actions'
// import { ChooseSubscriptionComponent } from '../components/auth/choose-subscription/choose-subscription.component'

class UrlService {
  private static instance: UrlService
  // eslint-disable-next-line @typescript-eslint/naming-convention
  private API_BASE = environment.apiBaseUrl

  static getInstance(): UrlService {
    if (!this.instance) {
      this.instance = new UrlService()
    }
    return this.instance
  }

  readonly endPoints = this.createRoutes([
    {
      base: 'auth',
      login: 'login',
      register: 'register',
      forgotPassword: 'forgot-password',
      resetPassword: 'reset-password',
      country: 'country',
      state: 'state',
      city: 'city',
      refreshToken: 'refresh-token',
      validateResetToken: 'validate-reset-token',
      logout: 'logout',
      chooseSubscription: 'chooseSubscription',
      switchUser: 'switch-user',
      revertSwitchUser: 'revert-switch-user'
    },
    {
      base: 'user',
      dashboard: 'dashboard',
      unauthorized: 'unauthorized',
      user: 'users',
      employeeDashboard: 'employeeDashboard',
      ownerDashboard: 'ownerDashboard',
      employeeRequest: 'employeeRequest',
      orgChart: 'orgChart',
      empResignation: 'empResignation',
      birthdays: 'birthdays',
      anniversary: 'anniversary'
    },

    {
      base: 'attendance',
      policies: 'policies',
      assignedPolicy: 'assigned-policy',
      attendancePolicyDetails: 'attendance-policy-details',
      employeeAttendance: 'employee-attendance',
      attendanceList: 'attendance-list',
      calander: 'calander'
    },
    {
      base: 'leaves',
      holidays: 'holidays',
      policies: 'policies',
      assignedPolicy: 'assigned-policy',
      appliedLeave: 'appliedLeave',
      leavesRequest: 'leavesRequest',
      assignedPolicyDetail: 'assigned-policy-detail',
      assignedPolicyBalance: 'assigned-policy-balance'
    },
    {
      base: 'company',
      salaryComponents: 'salary-components',
      business: 'business',
      businessOwner: 'businessowner',
      office: 'office',
      department: 'department',
      designation: 'designation',
      taxSettings: 'tax-settings'
    },
    {
      base: 'superAdmin',
      plans: 'plans',
      subscribers: 'subscribers',
      licenceHistory: 'licence-history', //For frontend route
      coupons: 'coupons',
      cron: 'cron'
    },
    {
      base: 'hrm',
      employee: 'employee',
      createSalary: 'salary',
      reviseSalary: 'revise-salary',
      updateSalary: 'update-salary',
      createPayout: 'payoutAgreement',
      revisePayout: 'revise-payout-agreement',
      updatePayout: 'update-payout-agreement',
      managePayroll: 'manage-payroll',
      runPayroll: 'run-payroll',
      payslip: 'payslip',
      payrollSummary: 'payroll-summary',
      investments: 'investments',
      manageContractorPayroll: 'manage-contractor-payroll',
      runContractorPayroll: 'run-contractor-payroll',
      contractorPayrollSummary: 'contractor-payroll-summary',
      invoice: 'invoice'
    },
    {
      base: 'planAndBilling',
      plan: 'plan',
      allSubscribers: 'all-subscribers',
      subscribersAnalytics: 'subscribers-analytics',
      paymentMethod: 'payment-method',
      subscriptionHistory: 'subscription-history', //For backend api
      previewAddLicences: 'preview-add-licences',
      addLicences: 'add-licences',
      removeLicences: 'remove-licences',
      updateSubscriptionStatus: 'update-subscription-status',
      updateTrialDays: 'update-trial-days',
      getPlansForBusiness: 'get-plans-for-business',
      upgradePlan: 'upgrade-plan',
      changePlanSummary: 'change-plan-summary',
      paymentCallback: 'payment-callback',
      paymentSuccess: 'payment-success',
      paymentFailure: 'payment-failure',
      activatePlan: 'activate-plan',
      planActivationSummary: 'plan-activation-summary',
      billing: 'billing',
      updateInvoiceBusiness: 'update-invoice-business'
    },
    {
      base: 'userRole',
      role: 'role',
      roledetails: 'roledetails',
      permissionSet: 'permissionSets',
      permissionsetdetails: 'permissionsetdetails'
    },
    {
      base: 'role',
      role: 'role',
      roledetails: 'roledetails',
      modules: 'modules'
    },
    {
      base: 'permissionSet',
      permissionSet: 'permissionSet',
      permissionSetdetails: 'permissionSetdetails'
    },
    {
      base: 'employeeManager',
      teamMembers: 'team-members'
    },
    {
      base: 'event',
      birthdays: 'birthdays',
      anniversary: 'anniversary'
    },
    {
      base: 'cron',
      cronSchedule: 'cron-schedule',
      admin: 'admin'
    },
    {
      base: 'notificationCampaign',
      list: '',
      schedule: 'schedule',
      templates: 'templates'
    },
    {
      base: 'userLoginHistory',
      list: ''
    },
    'clockInOut',
    'tasklogs',
    'family',
    'education',
    'experience',
    'bankDetail',
    'employeeleavebalance',
    'notifications',
    'payments'

    // 'business' //Route without children
  ] as const)

  private createRoutes<T extends readonly (string | { base: string; [key: string]: string })[]>(
    config: T
  ) {
    return config.reduce((acc, item) => {
      if (typeof item === 'string') {
        acc[item] = {
          [item]: item,
          [`${item}Api`]: `${this.API_BASE}/${item}`
        }
      } else {
        const { base, ...paths } = item
        acc[base] = {
          base,
          ...Object.fromEntries(
            Object.entries(paths).flatMap(([key, value]) => [
              [key, value],
              [`${key}Path`, `/${base}/${value}`],
              [`${key}Api`, `${this.API_BASE}/${base}/${value}`]
            ])
          )
        }
      }
      return acc
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    }, {} as any)
  }
}
export const eps = UrlService.getInstance().endPoints
